export const maskString = (str, mask = true, lastn = null) => {
  if (mask === false) return str;
  if (!str) return str;

  const len = str.length;

  // Default mask = 4 characters
  if (lastn === null) lastn = 4;

  // Special handling for short words
  if (len <= 3) lastn = 0;
  else if (len === 4) lastn = 1;
  else if (len === 5) lastn = 2;
  else if (len === 6) lastn = 3;
  else if (len === 7) lastn = 4;

  // If mask length exceeds or equals string length → mask everything
  if (lastn >= len) {return "*".repeat(len);}

  // Mask last n characters
  const visible = str.slice(0, len - lastn);
  const masked = "*".repeat(lastn);

  return visible + masked;
};





// maskFullNames.js
export const maskFullNames = (fullnames) => {

  if (!fullnames) return "";

  // each part is full names separated by "; "
  const parts = fullnames.split("; ");

  // If the structure is not as expected, bail out safely
  if (parts.length < 1) {return fullnames;}

  // each subpart is a full name with word parts separated by " "
  const delimiter = " ";

  // 251124 - I decided not to mask the first names, only the last names
  for (let i = 0; i < parts.length; i++) 
    {

    const subparts = parts[i].split(delimiter);

    for (let j = 1; j < subparts.length; j++) 
      {
      subparts[j] = maskString(subparts[j]);
      }

    parts[i] = subparts.join(delimiter);
    }

  // done. join and return
  return parts.join("; ");

};




// maskLogNotes.js
export const maskLogNotes = (notes) => {
  if (!notes) return "";

  const maskValueAfterEquals = (part, masker) => {
    const eqIndex = part.indexOf("=");

    if (eqIndex === -1) {
      return part;
    }

    const key = part.slice(0, eqIndex);
    const value = part.slice(eqIndex + 1);

    return `${key}=${masker(value)}`;
  };

  return notes
    .split("|")
    .map((part) => {
      const trimmed = part.trim();

      if (trimmed.startsWith("userno=")) {
        return maskValueAfterEquals(part, maskString);
      }

      if (trimmed.startsWith("fullname=")) {
        return maskValueAfterEquals(part, maskFullNames);
      }

      if (trimmed.startsWith("actor_userno=")) {
        return maskValueAfterEquals(part, maskString);
      }

      if (trimmed.startsWith("actor_fullname=")) {
        return maskValueAfterEquals(part, maskFullNames);
      }

      return part;
    })
    .join("|");
};
